import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {workExperiences} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function WorkExperience() {
  const {t} = useTranslation();
  const {isDark} = useContext(StyleContext);

  // Get translated experience data
  const translatedExperiences =
    t("experience.positions", {returnObjects: true}) || [];

  if (workExperiences.display) {
    return (
      <div id="experience">
        <Fade bottom duration={1000} distance="20px">
          <div className="experience-container" id="workExperience">
            <div>
              <h1 className="experience-heading">{t("experience.title")}</h1>
              <div className="experience-subtitle">
                {t("experience.subtitle")}
              </div>
              <div className="experience-cards-div">
                {translatedExperiences.map((translatedPosition, i) => {
                  // Get the original experience data for static assets like logos
                  const originalExperience = workExperiences.experience[i];

                  return (
                    <ExperienceCard
                      key={i}
                      isDark={isDark}
                      cardInfo={{
                        company: translatedPosition.company,
                        desc: translatedPosition.desc,
                        date: translatedPosition.date,
                        companylogo: originalExperience?.companylogo || "",
                        role: translatedPosition.role,
                        descBullets: translatedPosition.points
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </Fade>
      </div>
    );
  }
  return null;
}
